import React from 'react';
import { MapPinIcon, EditIcon, TrashIcon, CheckIcon } from 'lucide-react';
import { getCountryName } from '../utils/countryUtils';
export function AddressList({
  addresses,
  onEdit,
  onDelete,
  locale
}) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-16546">
      {addresses.map(address => <div key={address.id} className={`relative rounded-lg border ${address.isPrimary ? 'border-indigo-500' : 'border-gray-300'} bg-white px-6 py-5 shadow-sm flex flex-col space-y-2 hover:border-indigo-400`} data-id="element-16547">
          {address.isPrimary && <span className="absolute top-0 right-0 -mt-2 -mr-2 px-2 py-1 text-xs font-bold rounded-full bg-indigo-100 text-indigo-800 flex items-center" data-id="element-16548">
              <CheckIcon className="h-3 w-3 mr-1" data-id="element-16549" />
              Primary
            </span>}
          <div className="flex items-center space-x-3" data-id="element-16550">
            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-16551">
              <MapPinIcon className="h-6 w-6 text-gray-500" data-id="element-16552" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-16553">
              <p className="text-sm font-medium text-gray-900 truncate" data-id="element-16554">
                {address.addressType}
              </p>
            </div>
          </div>
          <div className="text-sm text-gray-500" data-id="element-16555">
            <p data-id="element-16556">{address.line1}</p>
            {address.line2 && <p data-id="element-16557">{address.line2}</p>}
            <p data-id="element-16558">
              {address.city}, {address.state} {address.postcode}
            </p>
            <p data-id="element-16559">{getCountryName(address.country)}</p>
          </div>
          <div className="flex justify-end space-x-2 mt-4" data-id="element-16560">
            <button type="button" onClick={() => onEdit(address)} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16561">
              <EditIcon className="h-4 w-4" data-id="element-16562" />
            </button>
            <button type="button" onClick={() => onDelete(address.id)} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-16563">
              <TrashIcon className="h-4 w-4" data-id="element-16564" />
            </button>
          </div>
        </div>)}
      {addresses.length === 0 && <div className="col-span-full text-center py-4 text-sm text-gray-500" data-id="element-16565">
          No addresses found. Click "Add Address" to create one.
        </div>}
    </div>;
}